import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getPagesHistory } from '../../containers/PagesHistory/selectors';
import { getAuthToken } from '../../containers/Auth/selectors';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import PATHS from '../../constants/paths';
import { InsightsInfoComponent } from './index';
import { useUserNotice } from '../../containers/UserProfile/UserNoticeHook';
import { UserNotice } from '../../containers/UserProfile/reducer';

interface Props {
  readonly isLoggedIn: boolean;
  readonly hasPages: boolean;
}

const enhance = compose<any, any>(
  withRouter,
  connect(state => {
    const pages = getPagesHistory(state);
    return {
      isLoggedIn: Boolean(getAuthToken(state)),
      hasPages: Object.keys(pages).length > 0,
    };
  }),
);

const InsightsInfo: React.FunctionComponent<Props & RouteComponentProps> = props => {
  const notice = useUserNotice(UserNotice.insightsPromoDidShow);

  const handleCreateAccountClick = () => {
    props.history.push(PATHS.AUTH.SIGN_UP);
  };

  const handleCreatePageClick = () => {
    props.history.push(PATHS.PAGES.NEW);
  };

  const handleViewInsightsClick = () => {
    notice.setValue(true);

    props.history.push(PATHS.STATISTICS.INDEX);
  };

  return (
    <InsightsInfoComponent
      hasPages={props.hasPages}
      isLoggedIn={props.isLoggedIn}
      onCreatePageClick={handleCreatePageClick}
      onCreateAccountClick={handleCreateAccountClick}
      onViewInsightsClick={handleViewInsightsClick}
    />
  );
};

export default enhance(InsightsInfo);



// WEBPACK FOOTER //
// ./src/components/InsightsInfoComponent/InsightsInfo.tsx